import Vue from 'vue';
import Vuex from 'vuex';
import userManager from './auth/userManagerInstance.js';
import router from './router.js';
import protectedAxios from './auth/axios.js';
import { jwtDecode } from "jwt-decode";

Vue.use(Vuex);

const authModule = {
  namespaced: true,
  state: {
    user: {
      id: '',
      profileId: '',
      login: '',
      name: '',
      profileName : '',
      branchNumber: '',
      profiles: [],
      role: [],
      admin: false,
      isDealer: false,
      frmLogged: false,
    },
    access_token: '',
    anonymous: true,
    loaded: false
  },
  getters: {
    loggedIn: state => {
      return state.anonymous == false && !!state.access_token && !!state.user.id;
    },
    isDealer: state => {
      return state.user.isDealer;
    },
    isLoaded: state => {
      return state.loaded;
    },
    isAnonymous: state => {
      return state.anonymous;
    },
    accessToken: state => {
      return state.access_token;
    },
    user: state => {
      return state.user;
    },
    hasRole: state => id => {
      return state.user.role.includes(id.toString());
    },
    allProfiles: state => {
      return state.user.profiles;
    },
    currentProfileName: state => {
      console.log('profileId: ' + state.user.profileId)

      console.log(state.user.profiles[0])
       let index = state.user.profiles.findIndex((val) => { return val.idProfilu == state.user.profileId })
      if (index > -1) {

        return state.user.profiles[index]?.nazov
      } else {
        return state.user.profiles[index]?.nazov
      }
    },
  },

  mutations: {
    setUser: async(state, user) => {
      state.user.id = user.profile.leasitUserId;
      state.user.profileId = user.profile.profileId;
      state.user.isDealer = user.profile.leasitUserId != 5;
      state.user.name = user.profile.meno;
      state.user.role = user.profile.liw_role !== undefined ? user.profile.liw_role.split(',') : [];
      state.user.admin = user.profile.admin == 'True';
      state.user.login = user.profile.login;
      state.user.frmLogged = user.profile.frml == 1;
      state.user.branchNumber = user.profile.cislo_pobocky;
      state.access_token = user.access_token;
      state.anonymous = false;
      state.loaded = true;
      if (state.user.isDealer == false) {
        await protectedAxios.get('/login/profiles').then((response) => state.user.profiles = response.data)
      }
    },
    setProfileId: (state, val) => {
      state.user.profileId = val;
    },
    setAccessToken: (state, val) => {
      state.access_token = val;
    },
    setProfileName: (state, val) => {
      state.user.profileName = val;
    },
    setAnonymousUser: async (state, anonymousToken) => {
      if (anonymousToken) {
        localStorage.setItem('curr_anonymous_liw_filip', anonymousToken)
      }

      let tokenData = jwtDecode(localStorage.getItem('curr_anonymous_liw_filip'))
     
      state.user.id = tokenData.leasitUserId;
      state.user.profileId = '';
      state.user.isDealer = false;
      state.user.name = tokenData.meno;
      state.user.role = tokenData.liw_role !== undefined ? tokenData.liw_role.split(',') : [];
      state.user.admin = false;
      state.user.login = tokenData.login;
      state.access_token = anonymousToken;
      state.user.frmLogged = true;
      state.anonymous = true;      
      state.loaded = true;
    },
    setSignOut(state) {
      state.user = {
        id: '',
        login: '',
        name: '',
        branchNumber: '',
        role: [],
        admin: false,
        frmLogged: false,
      };
      state.access_token = '';
    },
  },
  actions: {
    async setProfile(context, val) {
      let result = null;

      if (val != context.getters.user.profileId) {
          
         await protectedAxios.post('/login/change-profile',
            { idProfile: val, obcNum: localStorage.getItem('curr_new_obc_num') }).then(async (response) => {
              if (response.data) {
                result = response.data.redirectUrl
                context.commit('setProfileId', val);
                context.commit('setAccessToken', response.data.token);

                let index = context.getters.user.profiles.findIndex((val) => { return val.idProfilu == context.getters.user.profileId })
                if (index > -1) {
                 context.commit('setProfileName', context.getters.user.profiles[index]?.nazov)
                } else {
                 context.commit('setProfileName', '')
                }
              }
            })
          
          await userManager.signinSilent()

        }

      return result;
    },

    async authenticate(context, params) {
      const usr = await userManager.getUser();

      if (usr != null) {
        await context.dispatch('signInSilent');
      } else {
        context.dispatch('signIn', params);
      }
    },

    async signIn(context, params) {
      localStorage.setItem('localLoginReturnPage', params?.returnPath ?? '');
      if(params?.customQueryParams){
        let query = Object.keys(params.customQueryParams)
          .map(key => `${key}=${params.customQueryParams[key]}`)
          .join("&");
      
        if (query) {
          query = `?${query}`;
        }
      
        if(params?.returnPath)
          params.returnPath += query;
      }
      userManager.signinRedirect({ state: params?.returnPath, extraQueryParams: params?.customQueryParams });
    },

    async signInSilent({ commit, dispatch }) {
      await userManager
        .signinSilent()
        .then(async(user) => {
          await commit('setUser', user);
        })
        .catch(() => {
          dispatch('signOutLocalExpiredUserAndSignIn');
        });
    },

    signOut({ commit }) {
      return new Promise(resolve => {
        commit('setSignOut');
        userManager
          .signoutRedirect()
          .then(function (resp) {
            localStorage.removeItem('localLoginReturnPage');
            resolve();
          })
          .catch(function (err) {
            console.error(err);
          });
      });
    },

    signOutLocalExpiredUser({ commit }) {
      commit('setSignOut');
      userManager.removeUser();
      router.push('/login');
    },

    signOutLocalExpiredUserAndSignIn({ commit }) {
      commit('setSignOut');
      userManager.removeUser();
      userManager.signinRedirect();
    },

    async checkOtpGuid(context, otpGuid) {
      return protectedAxios
        .post('login/checkotpguid/' + otpGuid)
        .then(res => {
          return true;
        })
        .catch((err) => {
          console.error(err);
          return false;
        });
    },
  },
};

const variablesModule = {
  namespaced: true,
  state: {
    ext_suhlasy_displayed: false
  },
  getters: {
    isExtSuhlasyDisplayed: state => {
      return state.ext_suhlasy_displayed;
    },
  },
  mutations: {
    setExtSuhlasyDisplayed: (state, value) => {
      state.ext_suhlasy_displayed = value;
    },
  },
  actions: {
  },
};

export const store = new Vuex.Store({
  modules: { auth: authModule, variables: variablesModule},
  state: {
    pripad: {
      jeRozpracovany: null,
      handleExit: false, //ak je true a zaroven novy, tak pred odchodom z formularu, sa musi spytat, ci chce ulozit
      cislo: null,
      cisloPredmetu: null, //predmet, ktory si vyberie na editaciu
      canOpenPredmet: true,
      idZastupcu: null,
      cisloPlz: null,
      predmetZamknuty: true,
      newId:null,
      jeOlfs: false,
      jeFlSu: false
    },
    timeToCallApiAgain: 0, //cas po ktorom sa znova zavola nacitanie alebo ulozenie kontrolky ak bol problem s nacitanim alebo ukladanim kontrolky, cas je v ms
    wizardFormControls: [],
    otp: null, //One time password pouziva sa pre LoginOTP.vue
    fillCacheGuid: null,
    fullTextQuery: null,
    pripadFromPostParams: null,
    debug: false,
    pridatKontaktnuOsobu: false,
    vytvaranieZakaznikaPrebieha: false,
    odoslatNaSchvalenieRequest: {
      cisloObchPripadu: null,
      cisloPredmetu: null,
      varianty:[],
      newId:null
    },
    pravoNaAdresnuPonuku: false,
    pravoDodatocneKalkVstupy: true,
    jePrihlaseny: true,
    dialog: {
      width: 0,
      persistent: false,
      value: false,
      header: null,
      text: null,
      closeIcon: {
        value: false,
        func: null
      },
      primaryBtn: {
        text: null,
        func: null,
        disabled: false,
        loading: false,
      },
      secondaryBtn: {
        text: null,
        func: null,
        disabled: false,
        loading: false,
      },
      closeBtn: {
        value: false,
        text: 'Zavrieť',
        primaryStyle:  false
      },
      textClass:[],
      timer: null
    },
    loadingDialog:{
      open: false,
      btext: '',
      utext: '',
      zIndex: 5
    },
    externalUrl: null,
    externalUrlData: null,
    externalUrlFrom: null,
    externalUrlTimer: null,
    isMobile: false,
  },
  getters: {
    pripad: state => state.pripad,
    wizardFormControls: state => state.wizardFormControls,
    getWizardFormControl: (state) => (componentId) => {
          return state.wizardFormControls.find(control => control.dataId == componentId) ?? null;
    },
    otp: state => state.otp,
    fillCacheGuid: state => state.fillCacheGuid,
    fullTextQuery: state => state.fullTextQuery,
    pripadFromPostParams: state => state.pripadFromPostParams,
    debug: state => state.debug,
    pridatKontaktnuOsobu: state => state.pridatKontaktnuOsobu,
    vytvaranieZakaznikaPrebieha: state => state.vytvaranieZakaznikaPrebieha,
    odoslatNaSchvalenieRequest: state => state.odoslatNaSchvalenieRequest,
    pravoNaAdresnuPonuku: state => state.pravoNaAdresnuPonuku,
    pravoDodatocneKalkVstupy: state => state.pravoDodatocneKalkVstupy,
    jePrihlaseny: (state, getters, rootState, rootGetters) => {
      return rootGetters['auth/loggedIn']
    },
    dialog: state => state.dialog,
    loadingDialog: state => state.loadingDialog,
    jeDealer: (state, getters, rootState, rootGetters) => {
       return rootGetters['auth/isDealer']
    },
    externalUrl: state => state.externalUrl,
    externalUrlData: state => state.externalUrlData,
    externalUrlFrom: state => state.externalUrlFrom,
    timeToCallApiAgain: state => state.timeToCallApiAgain,
    isMobile: state => state.isMobile,
  },
  mutations: {
    setPravoNaAdresnuPonuku(state, val) {
      state.pravoNaAdresnuPonuku = !!val;
    },
    setPravoDodatocneKalkVstupy(state, val){
      state.pravoDodatocneKalkVstupy = !!val
    },
    setJePrihlaseny(state,val){
      state.jePrihlaseny = !!val
    },
    setPridatKontaktnuOsobu(state, val) {
      state.pridatKontaktnuOsobu = val;
    },
    setDebug(state, val) {
      state.debug = val;
    },
    setOdoslatNaSchvalenieRequest(state, val) {
      if (val) state.odoslatNaSchvalenieRequest = val;
      else
        state.odoslatNaSchvalenieRequest = {
          cisloObchPripadu: null,
          cisloPredmetu: null,
          varianty: [],
          newId: null
        };
    },
    setPripad(state, val) {
      if (val) state.pripad = val;
      else {
        localStorage.removeItem('curr_new_obc_num')
        state.pripad = {
          jeRozpracovany: null,
          handleExit: false,
          cislo: null,
          cisloPredmetu: null,
          canOpenPredmet: true,
          jeTechnologia: null,
          idZastupcu: null,
          cisloPlz: null,
          predmetZamknuty: false,
          newId: null,
          jeOlfs: false,
          jeFlSu: false
        };
      }
    },
    setCisloPredmetu(state, val) {
      state.pripad.cisloPredmetu = val;
    },
    setJeTechnologia(state, val) {
      state.pripad.jeTechnologia = val;
    },
    setIdZastupcu(state, val) {
      state.pripad.idZastupcu = val;
    },
    setHandleExit(state, val) {
      state.pripad.handleExit = val;
    },
    setJeRozpracovany(state, val) {
      state.pripad.jeRozpracovany = val;
    },
    setPredmetZamknuty(state, val) {
      state.pripad.predmetZamknuty = val;
    },
    setCanOpenPredmet(state, val){
      state.pripad.canOpenPredmet = val;
    },
    setFormControl(state, val) {
      let c = state.wizardFormControls.find(
        c =>
          c.dataId === val.dataId &&
          c.formName === val.formName &&
          c.cisloPredmetu === val.cisloPredmetu
      );

      if (!c) state.wizardFormControls.push(val);
    },
    deleteFormControl(state, val) {
      const deleteIndex = state.wizardFormControls.findIndex(
        c =>
          c.dataId === val.dataId &&
          c.formName === val.formName && (state.pripad.cislo == null ||
            c.cisloPredmetu === val.cisloPredmetu)
      );
      if (deleteIndex > -1) {
        state.wizardFormControls.splice(deleteIndex, 1);
      }
    },
    setFormControlDirty(state, val) {
      let c = state.wizardFormControls.find(
        c =>
          c.dataId === val.dataId &&
          c.formName === val.formName &&
          c.cisloPredmetu === val.cisloPredmetu
      );

      if (c) c.dirty = val.dirty;
    },
    setFormControlInitCompleted(state, val) {
      let c = state.wizardFormControls.find(
        c =>
          c.dataId === val.dataId &&
          c.formName === val.formName &&
          c.cisloPredmetu === val.cisloPredmetu
      );

      if (c) c.initComplete = val.initComplete;
    },
    setFormControlLoading(state, val) {
      let c = state.wizardFormControls.find(
        c =>
          c.dataId === val.dataId &&
          c.formName === val.formName &&
          c.cisloPredmetu === val.cisloPredmetu
      );

      if (c) c.isLoading = val.isLoading;
    },
    setOtp(state, val) {
      state.otp = val;
    },
    setfillCacheGuid(state, val) {
      state.fillCacheGuid = val;
    },
    setFullTextQuery(state, val) {
      state.fullTextQuery = val;
    },
    setPripadFromPostParams(state, val) {
      state.pripadFromPostParams = val;
    },
    setVytvaranieZakaznikaPrebieha: (state, val) => (state.vytvaranieZakaznikaPrebieha = val),
    openDialog: (state, val) => {
      state.dialog = {
        width: val?.width ?? 500,
        persistent: val?.persistent ?? false,
        value: true,
        header: val?.header,
        text: val?.text,
        closeIcon: {
          value: val?.closeIcon?.value ?? false,
          func: val?.closeIcon?.func ?? null
        },
        primaryBtn: {
          text: val?.primaryBtn?.text ?? null,
          func: val?.primaryBtn?.func ?? null,
          disabled: val?.primaryBtn?.disabled ?? false,
          loading: val?.primaryBtn?.loading ?? false,
        },
        secondaryBtn: {
          text: val?.secondaryBtn?.text ?? null,
          func: val?.secondaryBtn?.func ?? null,
          disabled: val?.secondaryBtn?.disabled ?? false,
          loading: val?.secondaryBtn?.loading ?? false,
        },
        closeBtn: {
          value: val?.closeBtn?.value ?? false,
          text: val?.closeBtn?.text ?? 'Zavrieť',
          primaryStyle: val?.closeBtn?.primaryStyle ?? false,
          disabled: val?.closeBtn?.disabled ?? false
        },
        textClass: val?.textClass,
        timer: val?.timer ?? null
      }
    },
    closeDialog:(state) => {
      clearTimeout(state.externalUrlTimer);
      state.externalUrl = null;
      state.externalUrlFrom = null;
      state.dialog = {
         width: 0,
        persistent: false,
        value: false,
        header: null,
        text: null,
        closeIcon: {
          value: false,
          func: null
        },
        primaryBtn: {
          text: null,
          func: null,
          disabled: false,
          loading: false,
        },
        secondaryBtn: {
          text: null,
          func: null,
          disabled: false,
          loading: false,
        },
        closeBtn: {
          value: false,
          text: 'Zavrieť',
          primaryStyle: false,
          disabled: false
        },
        textClass:[],
        timer: null
      }
    },
    setLoadingDialog: (state,val) => {
      state.loadingDialog.open = val?.open ?? false;
      state.loadingDialog.utext = val?.utext ?? "";
      state.loadingDialog.btext = val?.btext ?? "";
      state.loadingDialog.zIndex = val?.zIndex ?? 5;
    },
    setExternalUrl(state, val){
      clearTimeout(state.externalUrlTimer);
      if(state.externalUrl != null){
        state.externalUrl = null;
        state.externalUrlFrom = null;
      }
      state.externalUrlTimer = setTimeout(()=>{
        state.externalUrlFrom = val?.from ?? null;
        state.externalUrl = val.url;
        state.externalUrlData = val.data;
        if(state.pripad?.cislo == null ){
          window.location = val.url;
        }
      },50)
    },
    setTimeToCallApiAgain(state, val) {
      state.timeToCallApiAgain = val;
    },
    setMobile(state, width){
      state.isMobile = width < 960 ?? false;
    }
  },

  actions: {
    async fillCacheFromExternalForm({ getters, commit }) {
      await protectedAxios
        .post('externalform/fillcache/' + getters.fillCacheGuid)
        .then(res => {
          if (!res.data) {
            history.back()
          }
          if (res.data) {
            commit('setPripadFromPostParams', true);
            if (!res.data.startsWith('http')) {
              return router.push(`/${res.data}`).catch(e => e);
            }
            else {
              window.location.href = res.data
            }
          }
        })
    },
    async getPravoNaAdresnuPonuku({ commit }) {
      await protectedAxios.get('/login/pravo-na-adresnu-ponuku').then(res => {
          if (res?.data) {
            commit('setPravoNaAdresnuPonuku', res.data);
          }
      })
        .catch(function (err) {
          console.error(err);
        });
    },
    async getPravoDodatocneKalkVstupy({commit}){
      await protectedAxios.get('/login/pravo-dodatocne-kalk-vstupy').then(res => {
        if(res?.data){
          commit('setPravoDodatocneKalkVstupy',res.data);
        }
      })
    },
    async getTimeToCallApiAgain({commit}){
      await protectedAxios.get('/login/time-to-call-api-again').then(res => {
        if(res?.data){
          commit('setTimeToCallApiAgain',res.data);
        }
      })
    }
  },
});
